import {Injectable} from '@angular/core';
import {SubscriptionTrackingInfo} from '@lib/models/subscription/subscription-tracking-info';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTrackingService {
  public trackingInfoSubject = new BehaviorSubject<SubscriptionTrackingInfo>(null);
  public trackingInfo: SubscriptionTrackingInfo;

  constructor() { }

  public resetTrackingInfo(): void {
    this.trackingInfoSubject.next(null);
    this.trackingInfo = null;
  }

  public setTrackingInfo(trackingInfo: SubscriptionTrackingInfo): void {
    this.trackingInfoSubject.next(trackingInfo);
    this.trackingInfo = trackingInfo;
  }

  getTrackingInfo(): SubscriptionTrackingInfo | null {
    return this.trackingInfoSubject.getValue();
  }
}
